var menuMobile = function()
{

	var openMenu = $('header#mainHeader .mainMenuActions span.openMenu'),
		closeMenu = $('header#mainHeader .mainMenuActions span.closeMenu'),
		targetMenu = $('header#mainHeader nav'),
		openBusca = $('header#mainHeader .busca a.searchMenu'),
		formBusca = $('header#mainHeader .busca form');

	var closeMenuFunc = function()
	{
		$('body').css({'overflow':'auto'});
		closeMenu.removeClass('active');
		openMenu.addClass('active');
		targetMenu.removeClass('opened');
	}

	var closeBuscaFunc = function()
	{
		openBusca.removeClass('opened');
		formBusca.hide(200)
	}

	if($(window).width() <= 1365)
	{
		openMenu.click(function()
		{
			closeBuscaFunc();
			$('body').css({'overflow':'hidden'});
			$(this).removeClass('active');
			closeMenu.addClass('active');
			targetMenu.addClass('opened');
		});

		closeMenu.click(function()
		{
			closeMenuFunc();
		});
	}

	if($(window).width() <= 560)
	{
		openBusca.on('click',function(e)
		{
			e.preventDefault();

			closeMenuFunc();

			if(!$(this).hasClass('opened'))
			{
				$(this).addClass('opened');
				formBusca.show(200);
			}
			else
			{
				$(this).removeClass('opened');
				formBusca.hide(200);
			}
		});
	}
}

var lazyLoadImages = function(target)
{
	if(!target)
	{
		$('.lazyLoadImage').each(function()
		{
			if($(this).data('image'))
			{
				$(this).addClass('imageloaded').css({'background-image':'url('+$(this).data('image')+')'});
			}
		});
	}
	else
	{
		target.each(function()
		{
			$(this).addClass('imageloaded').css({'background-image':'url('+$(this).data('image')+')'});
		});
	}
}

var responsiveChanges = function()
{
	if($(window).width() <= 1024)
	{
		/* Destaques -> Tecnologia */
		$('#mainDisplay .blcGeral ul.postList').removeClass('vert medium').addClass('horiz small');
			lazyLoadImages($('#mainDisplay .blcGeral ul.postList li .lazyLoadImage'));
	}
	else
	{
		$('#mainDisplay .blcGeral ul.postList').removeClass('horiz small').addClass('vert medium');
			lazyLoadImages($('#mainDisplay .blcGeral ul.postList li .lazyLoadImage'));
	}

	if($(window).width() <= 992)
	{
		/* Tutoriais -> Tecnologia */
		$('#tutoriaisHome ul.postList').removeClass('vert medium').addClass('horiz small');
			lazyLoadImages($('#tutoriaisHome ul.postList li .lazyLoadImage'));
	}
	else
	{
		$('#tutoriaisHome ul.postList ul.postList').removeClass('horiz small').addClass('vert medium');
			lazyLoadImages($('#tutoriaisHome ul.postList li .lazyLoadImage'));
	}
}

var categorias = function()
{
	$('.printCategory').each(function()
	{
		$(this).text($(this).data('cat'));
	});
}

var swipers = function()
{
	var categorias = [];
	var	slugcats = [];

    $('.swipeDestaques .swiper-slide').each(function(i) {
      categorias.push($(this).data('category'));
      slugcats.push($(this).data('slugcats'));
    });

	var swiperDestaques = new Swiper('.swipeDestaques',
	{
		spaceBetween: 0,
		loop: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
	        el: '.swipeDestaques .swiper-pagination-destaque',
	        clickable: true,
	        renderBullet: function (index, className) {
	        	return '<span class="'+slugcats[index]+' '+className+'">'+categorias[index]+'</span>';
	    	},
	    },
    });
}

var propBox = function()
{
	var resizeBox = function(obj)
	{
		var nH = (315 * obj.width()) / 560;
		obj.css({'clear':'both'}).height(nH).stop().animate({opacity:1},300);
	}

	$('iframe, .propBox').each(function(){
		resizeBox($(this));
	});
}

var shareBoxPopUp = function()
{

	var openMenu = $('#headerInternas .header .sharePopUp .actionShare span.openMenu'),
		closeMenu = $('#headerInternas .header .sharePopUp .actionShare span.closeMenu'),
		targetMenu = $('#headerInternas .header .sharePopUp .shareButtons');

	openMenu.click(function()
	{
		$(this).removeClass('active');
		closeMenu.addClass('active');
		targetMenu.css({'display':'block','visibility':'visible'}).stop().animate({opacity : 1},200);
	});

	closeMenu.click(function()
	{
		$(this).removeClass('active');
		openMenu.addClass('active');
		targetMenu.stop().animate({opacity : 0},200,function()
		{
			$(this).css({'display':'none','visibility':'hidden'});
		});
	});
}

var blockquotes = function()
{
	$('#singlePostStyles blockquote').each(function()
	{
		var parent = $(this),
			label = parent.find('strong');

		if(label)
		{
			if(label.text() == 'Leia mais:' || label.text() == 'Leia mais: ')
			{
				parent.addClass('readMore');
			}
		}
	})
}

var textLimit = function()
{
	$(".textLimit").each(function()
	{
		var texto = $(this).text(),
			limit = $(this).data('limit');

		if(texto.length > limit)
		{
			$(this).text( texto.substr(0,limit)+"..." );
		}
	});
}

var headerComparadores = function()
{
	function numberToReal(numero) {
	    var numero = numero.toFixed(2).split('.');
	    numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
	    return numero.join(',');
	}

	var moedas = [1,1027,52];
	var html = '';

	for(var i = 0; i < moedas.length; i++)
	{
		$.ajax(
		{
			url: 'https://api.coinmarketcap.com/v2/ticker/'+moedas[i]+'/?convert=BRL',
			context: document.body,
			async: false,
		}).done(function(data)
		{
			var preco = data.data.quotes.BRL.price;
			$('header#mainHeader .cotacoes ul').append('<li><strong>'+data.data.symbol+'</strong> R$ '+numberToReal( preco )+'</li>');
		});
	}
}

var bannerSystem = function()
{
	function responsiveBanner(parent)
	{
		var image = parent.find('img'),
			imgDesktop = image.data('img-desktop'),
			imgTablet = image.data('img-tablet'),
			imgMobile = image.data('img-mobile');

		if($(window).width() >= 1024)
		{
			image.attr('src',imgDesktop);
		}		
		
		if($(window).width() < 1024)
		{
			if(imgTablet)
			{
				image.attr('src',imgTablet);
			}
			else
			{
				image.attr('src',imgDesktop);
			}
		}

		if($(window).width() < 560)
		{
			image.attr('src',imgMobile);
		}	

		parent.removeClass('inicial');
	}

	function trackingClicks(obj)
	{
//		obj.on('click',function(e)
//		{
			//e.preventDefault();
			//__gaTracker( 'send', 'bannerSystem', obj.data('cliente'), obj.data('display'), obj.data('pagina') );
		   	//window.open(obj.data('url'));
//		});
	}

	$('a.bannerSystem').each(function()
	{
		responsiveBanner($(this));
//		trackingClicks($(this));
	});
}

var playYoutubeEmbed = function()
{

	if($('.playYoutubeEmbed').length > 0)
	{
		$('.playYoutubeEmbed').on('click',function(e)
		{
			e.preventDefault();

			//$(this).addClass('active');
			//<iframe width="560" height="315" src="https://www.youtube.com/embed/53F5Y2QSEHY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			$(this).html('<iframe width="640" height="360" src="'+$(this).data('src')+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
			propBox();
		});
	}
}

$(function()
{
	responsiveChanges();
	categorias();
	swipers();
	menuMobile();
	blockquotes();
	textLimit();
	playYoutubeEmbed();

	$(window).resize(function()
	{
		menuMobile();
		propBox();
		responsiveChanges();
		bannerSystem();
	});

	window.onload = function()
	{
		propBox();
		lazyLoadImages();
		shareBoxPopUp();
		headerComparadores();
		bannerSystem();		
	}();
});
